export default {
  metadata: {
    version: '1.0.0',
    id: 'image-1.0.0',
    name: 'JDSImage'
  },
  hierarchy: {
    container: [
      'image',
      'lottie',
      'icon',
      'provider-slot',
      {
        'skeleton-container': ['skeleton-slot']
      }
    ]
  },
  base: {
    container: {
      'background-color': '{i_0}',
      'flex-direction': '{i_1}',
      'justify-content': '{i_2}',
      'align-items': '{i_3}',
      width: '{i_4}',
      height: '{i_5}',
      'border-radius': '{i_6}',
      overflow: 'hidden'
    },
    image: {
      hidden: false,
      width: '{i_9}',
      'object-position': 'center',
      'object-fit': 'cover',
      'aspect-ratio': '{i_7}',
      'border-radius': '{i_8}',
      'z-index': 0
    },
    lottie: {
      hidden: true,
      size: '{i_10}',
      repeat: true
    },
    icon: {
      hidden: true,
      value: 'ic_broken_image',
      size: '{i_11}',
      color: '{i_12}',
      'z-index': 1
    },
    'provider-slot': {
      hidden: true,
      width: '{i_13}'
    },
    'skeleton-container': {
      hidden: true,
      'z-index': 1,
      'aspect-ratio': '{i_14}',
      width: '{i_15}'
    },
    'skeleton-slot': {
      size: '{i_16}'
    }
  },
  variant: {
    contentScale: {
      contain: {
        image: {
          'object-fit': 'contain'
        }
      },
      fill: {
        image: {
          'object-fit': 'fill'
        }
      },
      fit: {
        image: {
          'object-fit': 'fit'
        }
      },
      fill_height: {
        image: {
          'object-fit': 'fill_height'
        }
      },
      fill_width: {
        image: {
          'object-fit': 'fill_width'
        }
      },
      none: {
        image: {
          'object-fit': 'none'
        }
      }
    },
    imageFocus: {
      left: {
        image: {
          'object-position': 'left'
        }
      },
      right: {
        image: {
          'object-position': 'right'
        }
      },
      top: {
        image: {
          'object-position': 'top'
        }
      },
      bottom: {
        image: {
          'object-position': 'bottom'
        }
      }
    },
    _state: {
      loading: {
        container: {
          'background-color': '{i_17}'
        },
        image: {
          opacity: '{i_18}'
        },
        'skeleton-container': {
          hidden: false
        }
      },
      empty: {
        container: {
          'background-color': '{i_19}'
        },
        image: {
          opacity: '{i_20}'
        },
        icon: {
          hidden: false,
          value: 'ic_image'
        }
      },
      error: {
        container: {
          'background-color': '{i_21}'
        },
        image: {
          opacity: '{i_22}'
        },
        icon: {
          hidden: false
        }
      }
    },
    _isLottieVisible: {
      true: {
        lottie: {
          hidden: false
        },
        image: {
          hidden: true
        },
        icon: {
          hidden: true
        },
        'skeleton-container': {
          hidden: true
        }
      }
    }
  },
  combination: [
    {
      round: {
        true: {
          container: {
            'border-radius': '1000'
          },
          image: {
            'border-radius': '1000'
          }
        },
        false: {
          container: {
            'border-radius': '1000'
          },
          image: {
            'border-radius': '1000'
          }
        }
      },
      square: {
        false: {
          container: {
            'border-radius': '0'
          },
          image: {
            'border-radius': '0'
          }
        }
      },
      horizontal_4_3: {
        true: {
          image: {
            'aspect-ratio': '{i_23}'
          },
          'skeleton-container': {
            'aspect-ratio': '{i_24}'
          }
        },
        false: {
          container: {
            'border-radius': '0'
          },
          image: {
            'border-radius': '0',
            'aspect-ratio': '{i_25}'
          },
          'skeleton-container': {
            'aspect-ratio': '{i_26}'
          }
        }
      },
      horizontal_5_4: {
        true: {
          image: {
            'aspect-ratio': '{i_27}'
          },
          'skeleton-container': {
            'aspect-ratio': '{i_28}'
          }
        },
        false: {
          container: {
            'border-radius': '0'
          },
          image: {
            'border-radius': '0',
            'aspect-ratio': '{i_29}'
          },
          'skeleton-container': {
            'aspect-ratio': '{i_30}'
          }
        }
      },
      horizontal_16_9: {
        true: {
          image: {
            'aspect-ratio': '{i_31}'
          },
          'skeleton-container': {
            'aspect-ratio': '{i_32}'
          }
        },
        false: {
          container: {
            'border-radius': '0'
          },
          image: {
            'border-radius': '0',
            'aspect-ratio': '{i_33}'
          },
          'skeleton-container': {
            'aspect-ratio': '{i_34}'
          }
        }
      },
      vertical_4_5: {
        true: {
          image: {
            'aspect-ratio': '{i_35}'
          },
          'skeleton-container': {
            'aspect-ratio': '{i_36}'
          }
        },
        false: {
          container: {
            'border-radius': '0'
          },
          image: {
            'border-radius': '0',
            'aspect-ratio': '{i_37}'
          },
          'skeleton-container': {
            'aspect-ratio': '{i_38}'
          }
        }
      },
      vertical_3_4: {
        true: {
          image: {
            'aspect-ratio': '{i_39}'
          },
          'skeleton-container': {
            'aspect-ratio': '{i_40}'
          }
        },
        false: {
          container: {
            'border-radius': '0'
          },
          image: {
            'border-radius': '0',
            'aspect-ratio': '{i_41}'
          },
          'skeleton-container': {
            'aspect-ratio': '{i_42}'
          }
        }
      },
      vertical_9_16: {
        true: {
          image: {
            'aspect-ratio': '{i_43}'
          },
          'skeleton-container': {
            'aspect-ratio': '{i_44}'
          }
        },
        false: {
          container: {
            'border-radius': '0'
          },
          image: {
            'border-radius': '0',
            'aspect-ratio': '{i_45}'
          },
          'skeleton-container': {
            'aspect-ratio': '{i_46}'
          }
        }
      },
      horizontal_2_75__1: {
        true: {
          container: {
            'border-radius': '0'
          },
          image: {
            'border-radius': '0',
            'aspect-ratio': '{i_47}'
          },
          'skeleton-container': {
            'aspect-ratio': '{i_48}'
          }
        },
        false: {
          container: {
            'border-radius': '0'
          },
          image: {
            'border-radius': '0',
            'aspect-ratio': '{i_49}'
          },
          'skeleton-container': {
            'aspect-ratio': '{i_50}'
          }
        }
      },
      none: {
        true: {
          image: {
            'aspect-ratio': ''
          },
          'skeleton-container': {
            'aspect-ratio': ''
          }
        },
        false: {
          container: {
            'border-radius': '0'
          },
          image: {
            'border-radius': '0',
            'aspect-ratio': ''
          },
          'skeleton-container': {
            'aspect-ratio': ''
          }
        }
      }
    }
  ],
  combination_config: [['aspectRatio', 'roundedCorner']],
  api: {
    config: {
      aspectRatio: {
        values: [
          'square',
          'round',
          'horizontal_4_3',
          'horizontal_5_4',
          'horizontal_16_9',
          'vertical_4_5',
          'vertical_3_4',
          'vertical_9_16',
          'horizontal_2_75__1',
          'none'
        ],
        doc_description:
          "It can be used to change the aspect ratio of Image. 'round' takes the '1:1' aspect ratio as default."
      },
      roundedCorner: {
        values: [true, false],
        doc_description:
          "Border radius on image. This is `True` by default for all aspect ratios except `aspectRatio='horizontal_2_75__1'`. `horizontal_2_75__1` doesn't accept rounded corner."
      },
      contentScale: {
        values: [
          'cover',
          'contain',
          'fit',
          'fill',
          'fill_height',
          'fill_width',
          'none'
        ]
      },
      imageFocus: {
        values: ['center', 'left', 'right', 'top', 'bottom'],
        doc_description: 'It can be used for reposition of the Image.'
      },
      _state: {
        values: ['loaded', 'loading', 'empty', 'error']
      },
      _isLottieVisible: {
        values: [false, true]
      }
    },
    data: {
      container: {
        '_image.alt': {
          type: 'string',
          name: 'alt',
          platform: 'web',
          function: true
        },
        width: {
          type: 'size',
          name: 'width',
          platform: 'ios'
        },
        height: {
          type: 'size',
          name: 'height',
          platform: 'ios'
        },
        'border-radius': {
          type: 'size',
          name: 'borderRadius',
          function: true
        }
      },
      image: {
        value: {
          type: 'image',
          name: 'src',
          function: true
        },
        'border-radius': {
          type: 'size',
          name: 'borderRadius',
          function: true
        },
        semantics: {
          type: 'string',
          name: 'semantics',
          platform: 'android'
        },
        coil_image_loader: {
          type: 'imageLoader',
          name: 'imageLoader',
          platform: 'android'
        }
      },
      lottie: {
        value: {
          type: 'image',
          name: 'src',
          function: true
        },
        attributes: {
          type: 'object',
          name: 'lottieAttributes',
          platform: 'android',
          object: {
            repeatCount: 'number',
            maxRetryCount: 'number',
            speed: 'float',
            reverseOnRepeat: 'boolean',
            clipSpec: 'LottieClipSpec'
          }
        }
      }
    },
    events: {
      image: {
        onClick: 'onClick',
        onHover: {
          name: 'onHover',
          platform: 'web'
        },
        onError: 'onError',
        onLoad: 'onLoad',
        onEmpty: 'onEmpty',
        onLoading: 'onLoading'
      }
    },
    children: {
      'provider-slot': {
        name: 'provider',
        accepts: ['any'],
        max: 1
      },
      'skeleton-slot': {
        name: 'skeleton',
        accepts: ['jds_skeleton'],
        max: 1
      }
    },
    a11y: {
      image: {
        properties: {
          role: {
            value: 'img'
          },
          'aria-label': {
            name: 'ariaLabel'
          },
          'aria-describedby': {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
